/**
 * ==============================
 * TECHNOW • Core JS
 * ==============================
 * Règles:
 * - Zéro mutation layout au chargement
 * - Logs activables via localStorage.TECHNOW_DEBUG = "1"
 */

(function () {
  // État global isolé
  const TECHNOW = (window.TECHNOW = window.TECHNOW || {});

  // Empêche un second chargement du même fichier
  if (TECHNOW.__loaded) return;
  TECHNOW.__loaded = true;

  // Debug localStorage: mettre TECHNOW_DEBUG="1" pour activer
  const debug = (typeof localStorage !== 'undefined' && localStorage.getItem('TECHNOW_DEBUG') === '1');
  TECHNOW.env = { ...(TECHNOW.env || {}), debug, version: '0.3.2' };

  const log = (...args) => { if (TECHNOW.env.debug) console.log('[TECHNOW]', ...args); };

  // =============================
  // [technow:FAQ] — helpers (hash + accordéon exclusif + tout fermé par défaut)
  // =============================
  function initTechnowFAQ() {
    // Garde anti-double init
    if (TECHNOW.__faqInit) return;
    TECHNOW.__faqInit = true;

    const roots = document.querySelectorAll('.technow .technow-faq');
    if (!roots.length) return;

    roots.forEach(root => {
      const items = root.querySelectorAll('.technow-faq__item');

      // 1) Tout fermer par défaut (peu importe les attributs)
      items.forEach(d => { d.open = false; });

      // 2) Accordéon exclusif : quand j’en ouvre un, les autres se ferment
      root.addEventListener('click', (e) => {
        const sum = e.target.closest('.technow-faq__summary');
        if (!sum) return;
        const current = sum.parentElement; // <details>
        // Laisse le toggle natif se produire, puis ferme les autres
        setTimeout(() => {
          if (current.open) {
            items.forEach(d => { if (d !== current) d.open = false; });
          }
        }, 0);
      });

      // 3) Ouvrir par hash (#faq-xxx) si présent
      const openByHash = () => {
        if (!location.hash) return;
        const target = root.querySelector(location.hash);
        if (target && target.tagName.toLowerCase() === 'details') {
          // Ferme tout puis ouvre la cible
          items.forEach(d => d.open = false);
          target.open = true;
          try { target.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
          catch (_) { target.scrollIntoView(true); }
        }
      };
      openByHash();
      window.addEventListener('hashchange', openByHash);
    });

    if (TECHNOW.env?.debug) console.log('[TECHNOW][FAQ] init OK');
  }

  console.log('[TECHNOW] JS chargé ✅'); // trace minimale

  document.addEventListener('DOMContentLoaded', () => {
    log('Initialisation');
    initTechnowFAQ(); // [technow:FAQ]
  });
})();

/* =============================
   [technow:MODULE] Title Ticker (Page Visibility)
   ============================= */
(function () {
  // Guard anti double-init (préviews / doubles inclusions)
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS._titleTickerInit) return;
  NS._titleTickerInit = true;

  // Valeurs par défaut (écrasées par la config JSON du <head>)
  const defaults = {
    enabled: true,
    messages: ["🙋‍♂️ Reviens vite !", "⚡ Ton kit 150 BPM t'attend"],
    period: 2000 // ms
  };

  // Lis la config injectée dans le <head>
  try {
    const $cfg = document.getElementById("technow-title-ticker-config");
    if ($cfg && $cfg.textContent) {
      const parsed = JSON.parse($cfg.textContent);
      Object.assign(defaults, parsed || {});
    }
  } catch (e) {
    // silencieux
  }

  // Option: désactiver dans l’éditeur de thème
  if (window.Shopify && Shopify.designMode) {
    defaults.enabled = false;
  }

  const originalTitle = document.title;
  let i = 0;
  let timer = null;

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    // Restaure exactement le titre initial
    document.title = originalTitle;
  }

  function start() {
    if (!defaults.enabled || !defaults.messages || !defaults.messages.length) return;
    if (timer) clearInterval(timer);
    i = 0;
    timer = setInterval(() => {
      document.title = defaults.messages[i % defaults.messages.length];
      i++;
    }, defaults.period);
  }

  function onVisibilityChange() {
    if (document.hidden) start();
    else stop();
  }

  document.addEventListener("visibilitychange", onVisibilityChange, { passive: true });
  window.addEventListener("beforeunload", stop, { passive: true });

  // Petite API console si besoin
  NS.titleTicker = {
    start,
    stop,
    enable(v = true) { defaults.enabled = !!v; if (!v) stop(); },
    setMessages(arr) { if (Array.isArray(arr) && arr.length) defaults.messages = arr; if (document.hidden && timer) start(); },
    setPeriod(ms) { if (typeof ms === "number" && ms >= 300) defaults.period = ms; if (document.hidden && timer) start(); }
  };
})();

// ============================
// [technow:CART-COUNT] — solide (hidden + classe visible + debounce + hook fetch)
// ============================
(function(){
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS.__cartCountInit) return;
  NS.__cartCountInit = true;

  NS.cartDebounceTimer = NS.cartDebounceTimer || null;

  async function tnwRefreshCartCount() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      const el = document.querySelector('[data-cart-count]');
      if (!el) return;

      // on neutralise tout style inline que quelque chose aurait pu injecter
      el.removeAttribute('style');

      const n = cart.item_count || 0;
      if (n > 0) {
        el.textContent = n;
        el.classList.add('cart-link__bubble--visible');
        el.removeAttribute('hidden');
      } else {
        el.textContent = '';
        el.classList.remove('cart-link__bubble--visible');
        el.setAttribute('hidden', '');
      }
    } catch (e) {/* noop */}
  }
  NS.tnwRefreshCartCount = tnwRefreshCartCount;

  function tnwRefreshCartCountDebounced(delay = 180) {
    clearTimeout(NS.cartDebounceTimer);
    NS.cartDebounceTimer = setTimeout(tnwRefreshCartCount, delay);
  }

  // Événements “maison”
  document.addEventListener('cart:updated', tnwRefreshCartCount);
  document.addEventListener('product:added', tnwRefreshCartCount);

  // Fallback: intercepte /cart/*
  (function(){
    const _fetch = window.fetch;
    window.fetch = function(i, init){
      const url = typeof i === 'string' ? i : (i?.url || '');
      const p = _fetch.apply(this, arguments);
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        p.then(() => tnwRefreshCartCountDebounced()).catch(() => {});
      }
      return p;
    };
  })();

  // Après submit d’un upsell (latence Shopify)
  document.addEventListener('submit', (e)=>{
    if (e.target && e.target.closest('.technow-upsell-card__form')) {
      setTimeout(tnwRefreshCartCount, 120);
      setTimeout(tnwRefreshCartCount, 400);
    }
  });

  // Init
  document.addEventListener('DOMContentLoaded', tnwRefreshCartCount);

  // Si le header est ré-injecté
  document.addEventListener('shopify:section:load', (e) => {
    if (e?.detail?.sectionId && String(e.detail.sectionId).includes('header')) {
      setTimeout(tnwRefreshCartCount, 50);
    }
  });
})();

// ============================
// [technow:UPSELL-BUTTON-RESET]
// Réactive les boutons upsell désactivés
// ============================
(function(){
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS.__upsellButtonResetInit) return;
  NS.__upsellButtonResetInit = true;

  function resetUpsellButtons() {
    document.querySelectorAll('.technow-upsell-card .technow-btn[disabled]').forEach(btn => {
      btn.disabled = false;
      btn.textContent = '+ AJOUTER';
    });
  }

  // Quand le panier est à jour (ton code déclenche déjà ces events)
  document.addEventListener('cart:updated', resetUpsellButtons);
  document.addEventListener('product:added', resetUpsellButtons);

  // Fallback : si un bouton est cliqué et reste bloqué, on le libère après un court délai
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.technow-upsell-card .technow-btn');
    if (!btn) return;
    // On attend 1.5s pour laisser l’app faire son job (ouverture slidecart, etc.)
    setTimeout(() => {
      if (btn.disabled) {
        btn.disabled = false;
        btn.textContent = '+ AJOUTER';
      }
    }, 1500);
  }, { passive: true });
})();

// ============================
// [technow:PRODUCT-TABS] — Ouvrir le 1er onglet réductible
// ============================
(function () {
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS.__openFirstTabInit) return;
  NS.__openFirstTabInit = true;

  function openOnlyFirst(scope) {
    // On ne prend que le 1er wrapper trouvé sur la page/section
    const root = (scope || document).querySelector('.product-block--tab .collapsibles-wrapper');
    if (!root) return;

    // 1er trigger de ce wrapper
    const trigger = root.querySelector('.collapsible-trigger');
    if (!trigger) return;

    // Contenu associé = frère direct (plus sûr) ; fallback sur aria-controls
    let content = trigger.nextElementSibling;
    if (!content || !content.classList || !content.classList.contains('collapsible-content')) {
      const id = trigger.getAttribute('aria-controls');
      if (id) content = document.getElementById(id);
    }
    if (!content) return;

    // Si déjà ouvert, ne rien faire
    if (trigger.classList.contains('is-open') && content.classList.contains('is-open')) return;

    // Ouvre proprement
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    content.classList.add('is-open');

    const hasTransition = getComputedStyle(content).transitionDuration !== '0s';

    // Force une ouverture visible si height est 0/absente, puis passe en auto
    if (!content.style.height || content.style.height === '0px') {
      content.style.height = content.scrollHeight + 'px';
    }

    if (hasTransition) {
      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        content.style.height = 'auto';
        content.removeEventListener('transitionend', onEnd);
      };
      content.addEventListener('transitionend', onEnd);
      setTimeout(() => {
        if (content.style.height !== 'auto') content.style.height = 'auto';
      }, 500);
    } else {
      content.style.height = 'auto';
    }
  }

  document.addEventListener('DOMContentLoaded', () => openOnlyFirst());
  document.addEventListener('shopify:section:load', (e) => openOnlyFirst(e.target));
})();